import React from "react";
import { Stack, Typography } from "@mui/material";

import {
  HubHookFormInput,
  HubHookFormSelect,
  UsersHookFormSelect,
} from "../../components";
import { TEMPLATES } from "../../constants/templates";

const ShipmentOrderDetails = ({ disabled, locationId = 1 }) => {
  return (
    <Stack width="100%" gap="5px">
      <Typography variant="boldCaptionMain">Shipment Order Settings</Typography>
      <Stack gap="15px">
        <HubHookFormSelect
          name="templateId"
          label="Template"
          options={TEMPLATES}
          defaultValue={1}
          disabled={disabled}
          required
        />
        <UsersHookFormSelect
          name="boxerId"
          label="Packaged By"
          locationId={locationId}
          required
        />
        <HubHookFormInput
          name="notes"
          label="Notes"
          placeholder="Notes..."
          disabled={disabled}
          disableHelperText
          multiline
          rows={5}
        />
      </Stack>
    </Stack>
  );
};

export default ShipmentOrderDetails;
